// extracted by mini-css-extract-plugin
export default {"title":"title-lCocA","conflictTableContent":"conflictTableContent-BWHpP","footer":"footer-QgcY4"};